<div class="resource-table">
  <app-resource-table
    #resourceTable
    [config]="tableConfig"
  ></app-resource-table>
</div>
